<template>
  <div class="confirmation-container">
    <el-card>
      <template v-if="!loading">
        <article  style="width: 100%;padding: 12px;" ref="imageWrapper" v-html="html"></article>
        <div class="btn" style="margin: 24px 0">
          <el-button type="primary" @click="handleSaveImage">{{ $t('registration.confirmation.save-image') }}</el-button>
          
          <!-- <el-button type="primary" @click="handleSendAgain">{{ $t('registration.confirmation.send-confirm') }}</el-button>
          <el-button style="margin-left: 18px" v-if="pageConfig.config.ReceiptDownload" type="primary" @click="handleReceipt">{{ $t('registration.confirmation.download-receipt') }}</el-button> -->


          <el-button v-if="!($event?.Config?.HideBuyAgain===true)"  type="primary" @click="$router.push({ name: 'ticket' })">{{ $t('registration.confirmation.buy-again') }}</el-button>

          
          <el-button style="margin-left: 18px" type="primary" @click="$router.push({ name: 'confirmation' })">{{ $t('registration.btn.back') }}</el-button>
        </div>
      </template>
    </el-card>
  </div>
</template>

<script setup>
  import { useEventListener } from '@vueuse/core'
  import { ref, inject, watch, onMounted } from 'vue'
  import { LANGUAGE } from '@/config'
  import { useAppStore } from '@/store/modules/app'
  import { storeToRefs } from 'pinia'
  import { useRouter, useRoute } from 'vue-router'
  import { confirmation, getReceipt } from '@/api/registration'
  import { getPageConfig } from '@/api/config'
  import { ElLoading } from 'element-plus'
  import html2canvas from 'html2canvas';

  const imageWrapper=ref(null)
  const $event = inject('$event')
  const html = ref('')
  const loading = ref(true)
  const pageConfig = ref({})

  const fetchData = async () => {
    loading.value = true
    const { ret, data } = await confirmation()
    if (ret === 0) {
      loading.value = false
      html.value = data.confirmation
    }
    //
  }

  onMounted(async () => {
    const { data } = await getPageConfig('confirmation')
    pageConfig.value = data
    await fetchData()
  })

  const handleSendAgain = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    const { ret, data } = await confirmation({ action: 'sent' })
    if (ret === 0) {
      loadingInstance.close()
    }
  }

  const handleReceipt = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    try {
      await getReceipt()
    } catch (e) {}
    loadingInstance.close()
  }


  
  const handleSaveImage=()=>{
    const clientWidth = imageWrapper.value.offsetWidth;
      const clientHeight = imageWrapper.value.offsetHeight;
      const kh = [clientWidth, clientHeight];

      html2canvas(imageWrapper.value, { useCORS: true, logging: true }).then((cvs) => {
        const dataURL = cvs.toDataURL('image/png');
        let canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 允许跨域
        img.src = dataURL;
        img.onload = () => {
          canvas.height = kh[1];
          canvas.width = kh[0];
          ctx.drawImage(img, 0, 0, kh[0], kh[1]);
          const dataURL = canvas.toDataURL('image/png');
          canvas = null;
          const link = document.createElement('a');
          link.href = dataURL;
          link.download = `${$event.EventName}.png`;
          link.click();
        }
      });
  }
</script>

<style lang="scss" scoped>
  .el-card {
    background: #ffffff;
    box-shadow: 0px 0px 16px rgba(54, 63, 94, 0.08);
    border-radius: 8px;
    border-width: 0;
    margin: 0;
    max-width: 960px;
    margin: 0 auto;
  }
  .confirmation-container {
    margin: 0;
    overflow-y: auto;
    max-height: 100%;
    padding: 20px;
  }

  article {
    width: 100%;
    :deep() {
      img {
        max-width: 100%;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
